import enviro from 'enviro';
import { useMemo } from 'react';
import { useGetSubscriptionHandler } from './useAblySubscriptionHandler';

// default state when no ably channel id is provided
const ablyDefaultState = {
  ablyChannelId: null,
  clientOptions: {},
  subscriptionHandler: () => {}
};
// Default values for disconnected/suspended retry are 15s and 30s
// Add 10s variation to avoid client reconnects storming the ably servers
// i.e. prevents clients from all trying to reconnect at the same time when there's a complete outage
const variation = Math.floor(Math.random() * 10) + 1;
const disconnectedRetryTimeout = (10 + variation) * 1000; //  10-20 seconds
const suspendedRetryTimeout = (20 + variation) * 1000; // 20-30 seconds

export const useAbly = ablyChannelId => {
  const subscriptionHandler = useGetSubscriptionHandler();

  // Memoize the client options to prevent recreating on each render
  const clientOptions = useMemo(() => {
    if (!ablyChannelId) {
      return {};
    }
    const hublet = enviro.getHublet();
    return {
      autoConnect: true,
      queryTime: true,
      disconnectedRetryTimeout,
      suspendedRetryTimeout,
      environment: `hubspot-${hublet}`,
      fallbackHosts: [`hubspot-${hublet}-a-fallback.ably-realtime.com`, `hubspot-${hublet}-b-fallback.ably-realtime.com`, `hubspot-${hublet}-c-fallback.ably-realtime.com`, `hubspot-${hublet}-d-fallback.ably-realtime.com`, `hubspot-${hublet}-e-fallback.ably-realtime.com`]
    };
  }, [ablyChannelId]); // Only recreate when the channel ID changes

  // Return a memoized state object to prevent unnecessary rerenders
  return useMemo(() => {
    if (!ablyChannelId) {
      return ablyDefaultState;
    }
    return {
      ablyChannelId,
      clientOptions,
      subscriptionHandler
    };
  }, [ablyChannelId, clientOptions, subscriptionHandler]);
};